import DOMPurify from "dompurify";

export function sanitizeMenuHtml(html: string): string {
  const template = document.createElement("template");
  template.innerHTML = DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });

  for (const link of template.content.querySelectorAll('a[target="_blank"]')) {
    const rel = new Set((link.getAttribute("rel") ?? "").split(/\s+/).filter(Boolean));
    rel.add("noopener");
    rel.add("noreferrer");
    link.setAttribute("rel", [...rel].join(" "));
  }

  return template.innerHTML;
}

export function htmlHasVisibleText(html: string): boolean {
  const template = document.createElement("template");
  template.innerHTML = DOMPurify.sanitize(html);
  return (template.content.textContent ?? "").trim().length > 0;
}
